<template>
<div class="chapter">
<div class="inner_page">
<div id="tp">
<p class="tit">How to Sew:<br/>Sew Basics</p>
<p class="copyrighttext"><b>This in-depth guide has been crafted by a team of experienced<br/>professionals, including award-winning cafters Susan Briscoe, Lynne<br/>Edwards and Dorothy Wood. Their expertise gives you the ideal<br/>introduction to the basics of sewing wonderful and creative designs.</b></p>
<p class="copyrighttext" style="text-align: left;"><b>Use your new found skills on great projects and more specific<br/>techniques by checking out the additional <i>How to Sew</i> range:</b></p>
<table border="0" cellpadding="1" cellspacing="1" frame="box" rules="all" summary="" width="100%">
<colgroup>
<col align="center"/>
<col align="center"/>
<col align="center"/>
</colgroup>
<tbody>
<tr>
<td align="center">
<i><b>Sashiko</b></i>
</td>
<td align="center">
<i><b>Decorative Sewing</b></i>
</td>
<td align="center">
<i><b>Bead Embroidery</b></i>
</td>
</tr>
<tr>
<td align="center">
<i><b>Patchwork</b></i>
</td>
<td align="center">
<i><b>Machine Sewing</b></i>
</td>
<td align="center">
<i><b>Felt Fabric</b></i>
</td>
</tr>
<tr>
<td align="center">
<i><b>Applique</b></i>
</td>
<td align="center">
<i><b>Hand Sewing</b></i>
</td>
<td align="center">
<i><b>Embellishments</b></i>
</td>
</tr>
</tbody>
</table>
<p class="copyrighttext" style="text-align: right;"><b>See the end of this book for more information on these   <br/>great titles, or to buy visit your favourite online retailer.</b></p>
<p class="center">
<img alt="logo" src="images/logo.jpg" style="max-width: 100%;"/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// _9780715338865_epub_tp.vue?414c6c00